import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=614ef630&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=js&"
export * from "./distribution.vue?vue&type=script&lang=js&"
import style0 from "./distribution.vue?vue&type=style&index=0&id=614ef630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ef630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614ef630')) {
      api.createRecord('614ef630', component.options)
    } else {
      api.reload('614ef630', component.options)
    }
    module.hot.accept("./distribution.vue?vue&type=template&id=614ef630&scoped=true&", function () {
      api.rerender('614ef630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accomodation/distribution.vue"
export default component.exports